export function setPrefix (obj = {}, preFix = "") {
  const objWithPrefix = {}
  Object.keys(obj).forEach(key => objWithPrefix[`${preFix}_${key}`] = obj[key])
  return objWithPrefix
}
